<template>
    <div
        v-if="show"
        class="d-block m-2 mt-5 mb-5"
        style="text-align: left; margin: auto; border: 1px solid #ccc"
    >
        <h3>
            Diagnostics:
        </h3>
        <form>
            <input v-model="showDetail" type="checkbox" id="showDetail" />
            <label for="showDetail">Show Details</label>
        </form>
        <div class="" v-if="showDetail">
            <!-- Metadata -->
            <h4 style="text-align:center"><strong>Metadata</strong></h4>
            <div
                v-for="(value, name, key) in app.currentConfiguration.metadata"
                :key="key"
                class="col-12"
            >
                <h6>{{ name }}</h6>
                <div v-html="value"></div>
            </div>

            <!-- Validation: Errors -->
            <h4 style="text-align:center"><strong>Validation</strong></h4>
            <div
                v-for="(value, name, key) in app.currentConfiguration.validation.errors"
                :key="key"
                class="col-12 alert alert-danger"
            >
                <h6>{{ name }}</h6>
                <div v-html="value"></div>
            </div>

            <!-- Validation: Warnings -->
            <div
                v-for="(value, name, key) in app.currentConfiguration.validation.warnings"
                :key="key"
                class="col-12 alert alert-warning"
            >
                <h6>{{ name }}</h6>
                <div v-html="value"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { app } from "../../application.js";


export default {
    name: "metadataComponent",

    data() {
        return {
            app: app,
            showDetail: false,
            show: false
        }
    },
    mounted() {
        if (app.env != 'prod') {
            this.show = true;
        }
    },
    methods: {

    }
}
</script>
